import type { PresenceSource } from './entry';
import { presenceSourceSchema } from './entry';
import type { SchemaOf } from '../helpers';
import { actionCreator, Joi, objectSchemaOf } from '../helpers';
import { PRESENCE_INPUT } from './topics';

export interface IPresenceNotifyParams {
  source: PresenceSource;
  sessionId: string;
  activationTimestamp: number;
}

export const presenceNotifyParamsSchemaMap: SchemaOf<IPresenceNotifyParams> = {
  source: presenceSourceSchema.required(),
  sessionId: Joi.string().required(),
  activationTimestamp: Joi.number().required(),
};

export const presenceNotifyParamsSchema = objectSchemaOf<IPresenceNotifyParams>(
  presenceNotifyParamsSchemaMap
);

export interface IPresenceNotifyPayload extends IPresenceNotifyParams {
  uid: string;
}

export const presenceNotifyPayloadSchema = objectSchemaOf<IPresenceNotifyPayload>(
  {
    ...presenceNotifyParamsSchemaMap,
    uid: Joi.string().required(),
  }
);

export const NOTIFY = 'PRESENCE/NOTIFY' as const;

export interface INotifyAction {
  type: typeof NOTIFY;
  payload: IPresenceNotifyPayload;
}

export const notifyActionSchema = objectSchemaOf<INotifyAction>({
  type: Joi.string().valid(NOTIFY).required(),
  payload: presenceNotifyPayloadSchema.required(),
});

export const notify = actionCreator({
  schema: notifyActionSchema,
  topic: PRESENCE_INPUT,
  type: NOTIFY,
});
